var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.className},_vm._l((_vm.value),function(v){return _c('div',{key:v},[_vm._v(" "+_vm._s(v)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }